"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitPackagingReport = void 0;
const packaging_set_line_data_response_1 = require("./packaging-set-line-data.response");
const shipping_kit_packaging_report_header_response_1 = require("./shipping-kit-packaging-report-header.response");
class ShippingKitPackagingReport {
}
exports.ShippingKitPackagingReport = ShippingKitPackagingReport;
//# sourceMappingURL=shipping-kit-packaging-report.response.js.map